import Altadena8x151 from "./tipe8x15 (1).png";
import Altadena8x152 from "./tipe8x15 (2).png";
import Altadena8x153 from "./tipe8x15 (3).png";

const altadena8x15 = [Altadena8x151, Altadena8x152, Altadena8x153];

export default altadena8x15;
